import "./dist/css/style.css";
import "./dist/css/style2.css";
import { Switch, Route } from "react-router-dom";
import Questions from "./components/questions/Questions";
import StartPage from "./components/StartPage";
import Output from "./components/Output";
import HomeCare from "./components/HomeCare";


const App = () => {
  return (
    <Switch>
      <Route path="/" exact children={<StartPage />} />
      <Route path="/questions" children={<Questions />} />
      <Route path="/output" children={<Output />} />
      <Route path="/home-care" children={<HomeCare />} />
      
    </Switch>
  );
};

export default App;
